import { getConfig } from './config';

// Generate TARGETS array dynamically from runtime config
export const getTargets = () => {
  try {
    const cfg = getConfig();
    return Array.isArray(cfg?.targets) ? cfg.targets : [];
  } catch (_) {
    return [];
  }
};

// Generate flag mapping from runtime config
const getFlagMapping = () => {
  const targets = getTargets();
  const flagMap = {};
  targets.forEach(target => {
    // Map target key to flag name (e.g., 'event' -> 'is_event_ticket')
    flagMap[target.key] = `is_${target.key}_ticket`;
  });
  return flagMap;
};

export function getTicketIndicators(ticket) {
  const targets = getTargets();
  const flagMap = getFlagMapping();
  
  return targets
    .filter(target => ticket?.[flagMap[target.key]] === true)
    .map(target => ` (${target.short})`)
    .join('');
}

export function getTicketFullLabels(ticket) {
  const targets = getTargets();
  const flagMap = getFlagMapping();
  
  return targets
    .filter(target => ticket?.[flagMap[target.key]] === true)
    .map(target => ` (${target.label})`)
    .join(', ');
}

// New utility function to get target chips for RequestManagement Details
export function getTargetChips(ticket) {
  const targets = getTargets();
  const flagMap = getFlagMapping();
  
  return targets
    .filter(target => ticket?.[flagMap[target.key]] === true)
    .map(target => ({
      label: "",
      value: target.label.toUpperCase(),
      className: "chipSecondary"
    }));
}

export function isApprovalAllowedForTicket(ticket) {
  try {
    const cfg = getConfig();
    const allowed = Array.isArray(cfg?.approvalAllowedTargets) ? cfg.approvalAllowedTargets : [];
    if (allowed.length === 0) return true; // if none explicitly allowed, UI won't block

    const flagMap = getFlagMapping();
    const selectedKeys = Object.entries(flagMap)
      .filter(([key, flag]) => ticket?.[flag] === true)
      .map(([key]) => key);

    if (selectedKeys.length === 0) return true; // default target
    return selectedKeys.every(k => allowed.includes(k));
  } catch (_) {
    return true;
  }
}
